<script>
import CardWrapper from "../../Shared/CardWrapper.vue";
import CardLayout from "../../Shared/CardLayout.vue";
import SelectInput from "../../Shared/SelectInput.vue";

export default {
    metaInfo: {
        title: Lang.get('employerdashboard::pages/employees-import/reupload.title'),
    },
    name: "reupload",
    components: { SelectInput, CardLayout, CardWrapper },
    props: {
        period: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            form: this.$inertia.form({
                file: null,
                confirm: false,
            }),
        }
    },
    methods: {
        uploadEmployeeFile() {
            this.form.post(this.route('nl.employerdashboard.employees-import.uploads.store-reupload', this.route().params))
        }
    },
    computed: {
        canSubmit() {
            return this.form.confirm && this.form.file !== null;
        }
    }
}
</script>

<template>
    <card-wrapper :title="Lang.get('employerdashboard::pages/employees-import/reupload.title', {period})"
                  :subtitle="Lang.get('employerdashboard::pages/employees-import/reupload.subtitle', {period})">
        <card-layout card_padding="p-3">
            <div class="mb-4 font-poppins font-weight-light" role="alert">
                <div class="bg-info-light color-dark-blue p-3 border-radius-8">
                    <p>
                        <i class="fa fa-exclamation-circle pr-2"/>
                        {{
                            Lang.get('employerdashboard::pages/employees-import/reupload.process_explanation')
                        }}
                    </p>
                </div>
            </div>

            <div class="form-group">
                <label for="period-select">
                    {{ Lang.get('employerdashboard::pages/employees-import/reupload.period') }}
                </label><br>
                <p class="form-control color-gray period">{{ period }}</p></div>
            <div class="form-group">
                <label class="form-label" for="file-upload">
                    {{ Lang.get('employerdashboard::pages/employees-import/reupload.employee_file') }}
                </label><br>
                <p class="error" v-if="form.errors.file">{{ form.errors.file[0] }}</p>
                <input class="form-control" type="file" id="file-upload" @input="form.file = $event.target.files[0]"/>
            </div>
            <div class="my-4 font-poppins font-weight-light attention-container border-radius-8" role="alert">
                <div class="color-white py-4 px-3">
                    <h4 class="color-white">
                        <i class="fa fa-exclamation-circle pr-2"></i>
                        {{
                            Lang.get('employerdashboard::pages/employees-import/reupload.attention')
                        }}
                    </h4>
                    <div class="pt-2">
                        <ol>
                            <li v-for="i in Array(4).keys()">
                                {{
                                    Lang.get(`employerdashboard::pages/employees-import/reupload.attention_points.${i}`)
                                }}
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <input type="checkbox" id="read-understood" v-model="form.confirm">
                <label class="form-label" for="read-understood">
                    {{ Lang.get('employerdashboard::pages/employees-import/reupload.read_understood') }}
                </label>
            </div>
            <div class="form-group">
                <button class="btn btn-primary font-poppins" :disabled="!canSubmit" @click="uploadEmployeeFile">
                    {{ Lang.get('employerdashboard::pages/employees-import/reupload.upload_employee_file') }}
                </button>
            </div>
        </card-layout>
    </card-wrapper>
</template>
<style lang="scss">
.attention-container {
    background-color: #33658A !important;
}

p.error {
    color: var(--danger);
    font-size: 12px;
}
p.period {
    cursor: text ;
}
</style>
